import { useContext, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { HubConnectionState } from "@microsoft/signalr";

import AlertContext, { ALERT_STATUS } from "context/alert/alertContext";

import SignalRContext from "../signalRContext";

export const useSignalRGroups = (groups: string[]) => {
    const { setAlert } = useContext(AlertContext);
    const { connection, state } = useContext(SignalRContext);

    const { t } = useTranslation();

    const groupsKey = [...groups].sort((a, b) => a.localeCompare(b)).join("|");

    useEffect(() => {
        if (!connection || state !== HubConnectionState.Connected || !groupsKey)
            return;

        const list = groupsKey.split("|");

        const join = async () => {
            try {
                await connection.invoke("JoinGroups", list);
            } catch {
                // Connection dropped mid-join - ignore, the effect rejoins automatically on reconnect
                if (connection.state !== HubConnectionState.Connected) return;

                setAlert({
                    status: ALERT_STATUS.Critical,
                    title: t("Flash##signalr join groups failed")
                });
            }
        };

        const leave = async () => {
            try {
                await connection.invoke("LeaveGroups", list);
            } catch {
                // Intentionally empty - leave fails when the connection is already closed and the server removes closed connections from all groups anyway
            }
        };

        join();

        return () => {
            leave();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connection, state, groupsKey]);
};
